import React, { useState } from "react";
import translate from "../../reusable/translate";
import PrimaryButton from "../../materialCommitment/buttons/PrimaryButton";
import SecondaryButton from "../../materialCommitment/buttons/SecondaryButton";
import ReactToPrint from "react-to-print";
import { useSelector } from "react-redux";

const CommitmentReportContainer = ({
  saveDraft,
  saveApproved,
  deleteDraft,
  printRef
}) => {
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [
    authorizedOnBehalfConfirmed,
    setAuthorizedOnBehalfConfirmed
  ] = useState(false);
  const [
    functionalBusinessConfirmed,
    setFunctionalBusinessConfirmed
  ] = useState(false);

  const { commitment, language } = useSelector(state => state);

  return (
    <div className="margin-top-bot do-not-print">
      <CheckBox
        textKey={"sit.commitmentCreation.circularEconomyGdCriteriaAccept"}
        action={() => {
          setTermsAccepted(!termsAccepted);
        }}
        languageOverride={language}
      />
      <CheckBox
        textKey={"sit.commitmentCreation.authorizedOnBehalf.871646"}
        action={() =>
          setAuthorizedOnBehalfConfirmed(!authorizedOnBehalfConfirmed)
        }
        languageOverride={language}
      />
      <CheckBox
        textKey={"sit.commitmentCreation.functionalBusiness.871646"}
        action={() =>
          setFunctionalBusinessConfirmed(!functionalBusinessConfirmed)
        }
        languageOverride={language}
      />

      <div className="margin-top-bot">
        <p
          dangerouslySetInnerHTML={{
            __html: translate({
              textKey: "sit.commitmentCreation.send.infotext.871646",
              secondaryTextKey: "sit.commitmentCreation.send.infotext",
              languageOverride: language
            })
          }}
        />
      </div>

      <div className="flex-row space-evenly margin-top-bot">
        <PrimaryButton
          action={() => saveApproved()}
          disabled={
            !(
              termsAccepted &&
              authorizedOnBehalfConfirmed &&
              functionalBusinessConfirmed
            )
          }
          textKey={
            commitment.status !== "approved"
              ? "sit.commitmentCreation.sendForVerification"
              : "sit.commitmentCreation.publishYourCommitment"
          }
          languageOverride={language}
        />

        {commitment.status !== "approved" && (
          <SecondaryButton
            action={() => saveDraft()}
            textKey={"sit.commitmentCreation.saveDraft"}
            languageOverride={language}
          />
        )}

        {commitment.status === "draft" && commitment.id && (
          <SecondaryButton
            action={() => deleteDraft()}
            textKey={"sit.commitmentCreation.deleteDraft"}
            languageOverride={language}
          />
        )}

        <ReactToPrint
          content={() => printRef.current}
          trigger={() => (
            <button className="secondary-button">
              <i className="fas fa-print" />{" "}
              {translate({
                textKey: "sit.commitmentCreation.printing",
                languageOverride: language
              })}
            </button>
          )}
        />
      </div>
    </div>
  );
};

export default CommitmentReportContainer;

const CheckBox = ({ textKey, action, languageOverride }) => {
  return (
    <div className="flex-row">
      <input
        className="input-checkbox"
        type="checkbox"
        onChange={() => action()}
      />
      <p className="p">
        {translate({ textKey: textKey, languageOverride: languageOverride })}
      </p>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/circularEconomyCommitment/commitment/CommitmentReportContainer.jsx